// extracted by mini-css-extract-plugin
export default {"tabWrapper":"topTabs_tabWrapper__tqoWj","tabItem":"topTabs_tabItem__MBN72","selected":"topTabs_selected__u4kbL"};